import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

const ProfilePageContext = createContext(null);

export function ProfileSidebarProvider({ children }) {
  const location = useLocation();
  const [active, setActive] = useState(2);
  const isProfilePage = location.pathname === "/user/profile";

  useEffect(() => {
    if (location.pathname !== "/user/profile") {
      setActive(2);
    }
  }, [location.pathname]);

  const value = useMemo(
    () => ({
      active,
      setActive,
      isProfilePage,
    }),
    [active, isProfilePage]
  );

  return <ProfilePageContext.Provider value={value}>{children}</ProfilePageContext.Provider>;
}

export function useProfilePage() {
  const ctx = useContext(ProfilePageContext);
  if (!ctx) {
    return {
      active: 2,
      setActive: () => {},
      isProfilePage: false,
    };
  }
  return ctx;
}

/** @deprecated use useProfilePage */
export function useProfileSidebar() {
  return useProfilePage();
}
